import { useState, useEffect } from 'react';

export const useResponseSwitching = (message) => {
  // Response switching state
  const [activeResponseIndex, setActiveResponseIndex] = useState(message?.activeResponseIndex || 0);
  
  // Sync with message's activeResponseIndex when it changes
  useEffect(() => {
    if (message?.activeResponseIndex !== undefined) {
      setActiveResponseIndex(message.activeResponseIndex);
    }
  }, [message?.activeResponseIndex]);
  
  // Get current response data
  const getCurrentResponse = () => {
    // During regeneration/streaming, always use the live message text
    if (message?.isRegenerating || message?.isStreaming) {
      return message;
    }
    
    // Otherwise, use the responses array for navigation
    if (message?.responses && message.responses.length > 0) {
      const response = message.responses[activeResponseIndex] || message.responses[0];
      return response;
    }
    return message;
  };
  
  // Response switching functions
  const handlePreviousResponse = () => {
    if (message?.responses && activeResponseIndex > 0) {
      const newIndex = activeResponseIndex - 1;
      setActiveResponseIndex(newIndex);
      // Note: In a full implementation, you might want to persist this to the backend
      // For now, it will reset on page refresh
    }
  };
  
  const handleNextResponse = () => {
    if (message?.responses && activeResponseIndex < message.responses.length - 1) {
      const newIndex = activeResponseIndex + 1;
      setActiveResponseIndex(newIndex);
      // Note: In a full implementation, you might want to persist this to the backend
      // For now, it will reset on page refresh
    }
  };

  const currentResponse = getCurrentResponse();
  
  return {
    activeResponseIndex,
    currentResponse,
    handlePreviousResponse,
    handleNextResponse,
    hasMultipleResponses: message?.responses && message.responses.length > 1
  };
}; 